import uid from 'quasar/src/utils/uid.js';import Platform from 'quasar/src/plugins/Platform.js';;
import OrderService from '../../lib/api/order.service';
import actions from '../../lib/api/actions';

export async function getOrder({ commit }, { orderId }) {
  const response = await OrderService.get({ orderId });
  if (response && response.status === 200) {
    commit('updateCurrentOrder', { order: response.data });
  }
}

export async function postOrder({ commit }, payload) {
  const response = await OrderService.post(payload);
  if (response && response.status === 200) {
    commit('updatePreviousOrder', { previousOrder: response.data.data });
  }
}

export async function addProduct({ commit, dispatch }, { product }) {
  // eslint-disable-next-line no-param-reassign
  product.uid = uid();
  commit('addProduct', { product });
  commit('updatePreviousOrder', { previousOrder: null });
  await dispatch('updateTotalPrice');
}

export async function addCurrentProduct({ dispatch, rootState }) {
  if (rootState.application.currentProduct) {
    const product = JSON.parse(JSON.stringify(rootState.application.currentProduct));
    await dispatch('addProduct', { product });
  }
}

export async function updateProduct({ commit, dispatch }, { product }) {
  commit('updateProduct', { product });
  await dispatch('updateTotalPrice');
}

export async function updateCurrentProduct({ commit, dispatch, rootState }) {
  if (rootState.application.currentProduct) {
    const product = rootState.application.currentProduct;
    if (product.uid) {
      commit('updateProduct', { product });
      commit('application/updateCurrentProduct', { product }, { root: true });
      await dispatch('updateTotalPrice');
    }
  }
}

export async function removeProduct({ commit, dispatch }, { product }) {
  commit('removeProduct', { product });
  await dispatch('updateTotalPrice');
}

export async function updateTotalDiscount({ commit, state }) {
  let totalDiscount = 0;

  if (state.coupon && state.coupon.discount > 0) {
    if (state.coupon.type === 1) {
      // Percentage discount
      state.products.filter((p) => p.discountable === 1).forEach((p) => {
        totalDiscount -= Math.floor(p.totalPrice * state.coupon.discount);
      });
    }
    else if (state.coupon.type === 2) {
      // Fixed discount
      let totalPrice = 0;
      state.products.filter((p) => p.discountable === 1).forEach((p) => {
        totalPrice += p.totalPrice;
      });

      if (totalPrice > state.coupon.discount) {
        totalDiscount = -state.coupon.discount;
      }
      else {
        totalDiscount = -totalPrice;
      }
    }
  }

  commit('updateTotalDiscount', { totalDiscount });
}

export async function updateTotalPrice({ commit, dispatch, state }) {
  let totalPrice = 0;
  state.products.forEach((product) => {
    totalPrice += product.totalPrice;
  });

  if (state.deliveryMethod) {
    totalPrice += state.deliveryMethod.priceImpact;
  }

  if (state.coupon) {
    await dispatch('updateTotalDiscount');
  }

  if (state.totalDiscount !== 0) {
    totalPrice += state.totalDiscount;
  }

  if (totalPrice < 0) {
    totalPrice = 0;
  }

  commit('updateTotalPrice', { totalPrice });
}

export async function flush({ commit }) {
  commit('flush');
}

export async function checkIfValidCouponCode({ commit }, { coupon, deliveryMethodId }) {
  const response = await actions.checkIfValidCouponCode({ coupon, deliveryMethodId });

  if (response.status === 200) {
    if (response.data.context === 2 && Platform.is.cordova) {
      throw new Error('couponNeedsDesktop');
    }
    else if (response.data.context === 3 && !Platform.is.cordova) {
      throw new Error('couponNeedsCordova');
    }
    else {
      commit('setValidCouponCode', response.data);
    }
  }
}
